import { agencyUrls } from './agencyUrls';
import { appUrls } from './appUrls';
import { curologyUrls } from './curologyUrls';

export const urls = {
  app: appUrls,
  curology: curologyUrls,
  agency: agencyUrls,
} as const;

export { getActiveAgencyUrls } from './getActiveAgencyUrls';
export { getActiveUrls } from './getActiveUrls';
